var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"filter-toggle-menu-item",class:{active: _vm.active},on:{"click":_vm.onClick}},[_c('span',{staticClass:"fas fa-fw fa-check"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }